import { DataPage, DataStore } from "@xbs/muon";
import { getCellIds } from "./../helpers/main";
import { IAction, IActionConfig, SpreadsheetEvents } from "./../types";

export class LockCell implements IAction {
	public config: IActionConfig;
	private _store: DataStore;
	private _page: DataPage;

	constructor(config: IActionConfig) {
		this.config = config;
		this._store = config.dataStore;
		this._page = config.page;
	}

	do() {
		const { val, cell, grid } = this.config;
		const { row, col } = getCellIds(cell, grid);

		this._page.setCell(row, col, { locked: val });
		if (val) {
			this.config.editLine.lock();
		} else {
			this.config.editLine.unlock();
		}
		this.config.spreadsheet.events.fire(SpreadsheetEvents.afterFocusSet, [cell]);
	}

	undo() {
		const { val, cell, grid } = this.config;
		const { row, col } = getCellIds(cell, grid);

		this._page.setCell(row, col, { locked: !val });
		this.config.spreadsheet.events.fire(SpreadsheetEvents.afterFocusSet, [cell]);

		if (val) {
			this.config.editLine.unlock();
		} else {
			this.config.editLine.lock();
		}
	}
}
